/* eslint import/prefer-default-export: 0 */

import { get, isObject } from 'lodash/fp';

export function getPassiveIfSupported() {
  let passiveIfSupported = false;

  try {
    window.addEventListener('test', null, Object.defineProperty({}, 'passive', { get() { passiveIfSupported = { passive: true }; } }));
  } catch (err) {
    // do nothing
  }
  return passiveIfSupported;
}

export function postMessageToRN(message = {}) {
  if (!isObject(message)) {
    console.warn('postMessageToRN expects an object');
    return;
  }
  let retryTime = 0;
  const timeout = 10000; // we'll try for 10 seconds
  const interval = 100;
  function whenRNPostMessageReady(cb) {
    if (retryTime >= timeout) return; // give up
    if (window.postMessage.length === 1) {
      cb();
    } else {
      setTimeout(() => { whenRNPostMessageReady(cb); }, interval);
      retryTime += interval;
    }
  }

  // tell React Native we've mounted because its RN Webview's onload hook waits for ALL requests to finish
  if (get('webkit.messageHandlers.reactNative.postMessage', window)) {
    // post to iOS
    window.webkit.messageHandlers.reactNative.postMessage(message);
  } else if (window.postMessage) {
    const stringMessage = JSON.stringify(message);

    // Post message to new android app
    if (window.Android && (typeof window.Android.postMessage === 'function')) {
      window.Android.postMessage(stringMessage);
      return;
    }

    // post to Android
    whenRNPostMessageReady(() => {
      // react native accepts strings only
      if (get('parent.postMessage', window)) window.parent.postMessage(stringMessage, '*');
    });
  }
}

export function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0
    && rect.left >= 0
    && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
